import React from "react";
import { BOOKS } from "../data/site";
import { ArrowUpRight } from "lucide-react";

export default function BooksCTA() {
  const items = BOOKS.filter((b) => b.link);
  if (items.length === 0) return null;

  return (
    <section
      className="border-t border-border"
      data-testid="books-cta"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <header className="mb-12 md:mb-16">
          <p className="label mb-3">From the Studio — Picture Books</p>
          <h2 className="serif text-4xl md:text-5xl tracking-tight font-light leading-[1.05]">
            Stories for the next
            <br />
            <span className="italic text-[hsl(var(--ink-soft))]">
              generation of artists.
            </span>
          </h2>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20">
          {items.map((b) => (
            <a
              key={b.id}
              href={b.link}
              className="group block"
              data-testid={`books-cta-${b.id}`}
            >
              <div className="aspect-square overflow-hidden bg-[hsl(var(--surface))]">
                <img
                  src={b.cover}
                  alt={`${b.title} — book cover`}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.02]"
                />
              </div>
              <div className="mt-6 flex items-start justify-between gap-6">
                <div>
                  <p className="label mb-2">
                    Picture Book · {b.year}
                    {b.format ? ` · ${b.format}` : ""}
                  </p>
                  <h3 className="serif text-3xl md:text-4xl tracking-tight font-light leading-tight">
                    {b.title}
                  </h3>
                </div>
                <ArrowUpRight className="h-5 w-5 mt-2 text-[hsl(var(--ink-soft))] transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </div>
            </a>
          ))}
        </div>

        <div className="mt-14 md:mt-20">
          <p className="text-sm text-[hsl(var(--ink-soft))]">
            Both titles available at{" "}
            <a
              href="https://gravescollective.com"
              target="_blank"
              rel="noopener noreferrer"
              className="link-underline text-foreground"
              data-testid="books-cta-graves-link"
            >
              Graves Collective →
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
